import React, { Fragment } from 'react';

import './Terms.css';
import { t } from 'i18next';

export default ({ term }) => {
  return (
    <Fragment>
      {!!term && (
        <Fragment>
          <div className="terms-and-condition terms_condition_main">
            <h5 className="heading">{t('common.termsAndConditions')}</h5>
            {/* <p style={{wordBreak: 'break-all'}}>{term}</p> */}
            <textarea
              className={`float-left w-100 terms-box term-area-set`}
              value={term}
              disabled={true}
              ref={(el) => {
                if (el) el.style.height = el.scrollHeight + 'px';
              }}
            />
            {/* <hr className="float-left w-100"/> */}
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};
